import { IconProps, Stack } from "@chakra-ui/react";
import { ChevronDownIcon } from "./ChevronDown";
import { ChevronUpIcon } from "./ChevronUp";

export function ChevronCloseVertical(props: IconProps) {
  const { width = "32px" } = props;

  return (
    <Stack spacing={`calc(${width} * -0.05)`}>
      <ChevronDownIcon {...props}/>
      <ChevronUpIcon {...props}/>
    </Stack>
  );
}
